import React from 'react';
import SectionHeading from './SectionHeading';
import { faqs } from '../data/content';

function FullLicence() {
  return (
    <section className="section dark licence-section" aria-label="Licence terms">
      <div className="container">
        <div className="licence-copy">
          <p>
            Leadership Skills Folder — Private Label Rights Licence
            <br />
            Key Future Skills · Licensed to the purchaser on download
          </p>
          <p>
            Granted: a non-exclusive, non-transferable, worldwide, perpetual
            right to modify the included materials, publish them under the
            purchaser's own name and branding, and sell or distribute the
            resulting derivative works commercially.
          </p>
          <p>
            Not granted: the right to redistribute the unmodified files; the
            right to grant private label, resale or master resale rights to any
            third party; the right to distribute the materials free of charge
            or through file-sharing services; ownership of the underlying
            copyright, which remains with Key Future Skills.
          </p>
          <p>
            This licence covers one purchaser. It cannot be sold, shared or
            transferred to another person or company.
          </p>
        </div>
        <p className="refund-note">
          Because the licence transfers on download, this product isn't
          refundable. The full terms are above so you can read them before you buy.
        </p>
      </div>
    </section>
  );
}

function FAQ() {
  return (
    <section className="section light">
      <div className="container narrow">
        <SectionHeading eyebrow="Before you buy">
          Frequently asked questions
        </SectionHeading>
        <div className="faq-list">
          {faqs.map(({ question, answer }) => (
            <details key={question}>
              <summary>
                <span>{question}</span>
                <span className="faq-marker" aria-hidden="true">+</span>
              </summary>
              <p>{answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export { FullLicence, FAQ };